import {
  BaseService,
  Status,
  DataResponse,
  MessageResponse,
  MessageData,
} from './base.service';
import { Feedback } from '@/models/feedback.model';

class FeedbackService extends BaseService {
  private url: string = '/api/feedback';

  constructor() {
    super();
  }

  public async getList(): Promise<DataResponse<Feedback[]>> {
    const res = await this.$http.get<Feedback[]>(`${this.url}`);
    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async update(
    id: number,
    data: Partial<Feedback>,
  ): Promise<DataResponse<Feedback>> {
    const res = await this.$http.put<Feedback>(`${this.url}/${id}`, {
      id,
      ...data,
    });

    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async delete(id: number): Promise<MessageResponse> {
    const res = await this.$http.delete<MessageData>(`${this.url}/${id}`);

    return {
      status: res.status === Status.Ok,
      message: res.data.message,
    };
  }
}

export default new FeedbackService();
